import React, { useEffect, useState } from "react";
import {
  Switch,
  Route,
  withRouter,
  useLocation,
  useHistory,
} from "react-router-dom";
import liff from "@line/liff";
import MemberProfile from "./MemberProfile";
import AppConfig from "./AppConfig.json";
import axios from "axios";
import { connect } from "react-redux";
import * as actions from "./actions";
import PinProtectScreen from "./PinProtectScreen";
import MemberEditEmail from "./MemberEditEmail";
import MemberEditMobile from "./MemberEditMobile";
import MemberEditAddress from "./MemberEditAddress";
import MemberEditInterest from "./MemberEditInterest";
import LinkedScreen from "./LinkedScreen";
import AATagging from "./AATagging";

import UnlinkScreen from "./UnlinkScreen";
import { isMissionStickerCampaign } from "./Helper";

// A custom hook that builds on useLocation to parse
// the query string for you.
export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function MemberRoutes({
  match,
  app,
  setCurrentUserProfile,
  setAccessToken,
  setCurrentLoyaltyMemberDetail,
}) {
  let { path } = match;
  let history = useHistory();
  let [message, setMessage] = useState("");
  let [loading, setLoading] = useState(true);
  let [lineAccessToken, setLineAccessToken] = useState("");
  let query = useQuery();

  const urlParams = new URLSearchParams(window.location.search);
  let state = urlParams.get("liff.state");
  // let history = useHistory();

  useEffect(() => {
    console.log("Mission Sticker ");
    setMessage("...");

    initializeLiff(AppConfig.liff_id);
  }, []);

  async function initializeLiff(myLiffId) {
    setMessage("Initializing");

    let timeout = setTimeout(() => {
      window.location.href = `https://liff.line.me/${myLiffId}`;
      window.location.reload();
    }, 3000);

    const isInCypress = window.Cypress ? true : false;
    console.log("isInCypresss : ", isInCypress);

    try {
      await liff.init({ liffId: myLiffId });
      clearTimeout(timeout);

      setMessage("Initialize...");

      if (state) {
        state = decodeURIComponent(state);

        if (state.includes("/member/linked")) {
          // setTimeout(() => {
          // liff.closeWindow()
          // }, 3000)

          history.push(state);
        } else if (state.includes("member")) {
          history.push(state);
        }
      }

      if (isInCypress) {
        localStorage.setItem(
          "LIFF_STORE:1656222168-vxA0DDWa:accessToken",
          process.env.REACT_APP_LIFF_TOKEN
        );

        setMessage("Checking account");

        let line_access_token = process.env.REACT_APP_LIFF_TOKEN;
        setLineAccessToken(line_access_token);
        if (window.location.href.includes("member/signup")) {
          console.log("Signup");
          redirectToSignup(line_access_token);
        } else if (
          !window.location.href.includes("member/error") &&
          !window.location.href.includes("member/message")
        ) {
          loadUserProfile(line_access_token);
        } else {
          setLoading(false);
        }
      } else {
        if (!liff.isLoggedIn()) {
          setMessage(".....");
          liff.login();
        } else {
          setMessage("Checking account");

          let line_access_token = liff.getAccessToken();
          setLineAccessToken(line_access_token);
          if (window.location.href.includes("member/signup")) {
            console.log("Signup");
            redirectToSignup(line_access_token);
          } else if (
            !window.location.href.includes("member/error") &&
            !window.location.href.includes("member/message")
          ) {
            loadUserProfile(line_access_token);
          } else {
            setLoading(false);
          }
        }
      }
    } catch (err) {
      // Error happens during initialization
      // alert("Error")

      setMessage("Cannot Initialize..." + err.message);
      window.location.href = `https://liff.line.me/${AppConfig.liff_id}`;
      window.location.reload();
      // setMessage(err.message)
      // history.push('/member/error')
    }
  }

  async function loadUserProfile(line_access_token) {
    console.log("Load user profile");
    setLoading(true);
    setAccessToken(line_access_token);
    setMessage("Checking account...");

    let missionStickerMode = window.location.href.includes(
      "member/missionsticker"
    );

    // Request auth link
    let result = await axios.post(
      `${AppConfig.endpoint}/member/binding`,
      {},
      {
        headers: {
          "x-access-token": line_access_token,
          "x-api-key": AppConfig.api_key,
        },
      }
    );

    // setMessage(JSON.stringify(result.data))
    if (result.data && result.data.url) {
      if (missionStickerMode) {
        history.push("/member/missionsticker");
      } else {
        AATagging.trackSignin();
        setTimeout(() => {
          window.location.href = result.data.url;
        }, 1000);
      }
    } else {
      // Request profile
      let profileData = null;
      try {
        let result = await axios.post(
          `${AppConfig.endpoint}/member/profile`,
          {},
          {
            headers: {
              "x-access-token": line_access_token,
              "x-api-key": AppConfig.api_key,
            },
          }
        );

        profileData = result.data;

        if (profileData) {
          const loyaltyData = await axios.post(
            `${AppConfig.endpoint}/member/loyalty/detail`,
            {},
            {
              headers: {
                "x-access-token": line_access_token,
                "x-api-key": AppConfig.api_key,
              },
            }
          );

          if (loyaltyData.data) {
            setCurrentLoyaltyMemberDetail(loyaltyData.data);
          }
        }
      } catch (err) {
        // history.push('/member/error/profile')
        setLoading(false);
      }

      if (profileData) {
        setCurrentUserProfile(profileData);

        if (window.location.href.includes("member/missionsticker")) {
          try {
            let result = await axios.post(
              `${AppConfig.endpoint}/member/sticker`,
              {},
              {
                headers: {
                  "x-access-token": line_access_token,
                  "x-api-key": AppConfig.api_key,
                },
              }
            );

            if (result.data) {
              // history.push("/member/mission_consent")
              history.push("/member/linked/t1");
            }
          } catch (err) {
            // history.push('/member/error/profile')
            setLoading(false);
          }
        } else if (!window.location.href.includes("member/linked")) {
          history.push("/member/profile");
        }
      } else {
        // Session data break then rebinding account
        // Request auth link
        let result = await axios.post(
          `${AppConfig.endpoint}/member/binding`,
          {},
          {
            headers: {
              "x-access-token": line_access_token,
              "x-api-key": AppConfig.api_key,
            },
          }
        );

        if (result.data && result.data.url) {
          // Redirect to signin screen
          if (missionStickerMode) {
            history.push("/member/missionsticker");
          } else {
            window.location.href = result.data.url;
          }
        } else {
          // history.push('/member/error')
        }
      }

      // history.push('/member/error/binding')
      setLoading(false);
    }

    setLoading(false);
  }

  async function redirectToSignup(line_access_token) {
    AATagging.trackSignup();

    let result = await axios.post(
      `${AppConfig.endpoint}/member/binding`,
      { mode: "signup" },
      {
        headers: {
          "x-access-token": line_access_token,
          "x-api-key": AppConfig.api_key,
        },
      }
    );

    if (result.data && result.data.url) {
      setTimeout(async () => {
        window.location.href = result.data.url;
      }, 1500);
    } else {
      // history.push('/member/error/binding')
      setLoading(false);
    }
  }
  async function signOut(access_token, line_access_token) {
    try {
      await axios.post(
        `${AppConfig.endpoint}/member/signout`,
        {
          access_token,
        },
        {
          headers: {
            "x-access-token": line_access_token,
            "x-api-key": AppConfig.api_key,
          },
        }
      );
    } catch (err) {
      // alert(err.message)
    }
    liff.closeWindow();
  }

  return (
    <>
      {loading && (
        <div
          className="has-text-centered"
          style={{ fontSize: 8, padding: 16, color: "#444" }}
        >
          <img src="/spinner.gif" style={{ height: 40 }} />
          <br />
          {message}
        </div>
      )}
      <Switch>
        <Route path={`${path}/member/mission_consent`}>
          <div
            className="error-page has-text-centered"
            style={{ paddingTop: 40 }}
          >
            <div className="subtitle" style={{ fontSize: 24 }}>
              Confirm consent
            </div>
            เนื่องจากคุณได้ทำการยอมรับ Terms and condition
            <br />
            คุณสามารถคลิกเพื่ออ่านรายละเอียด ได้ที่นี่
            <div className="screen-footer">
              <button
                onClick={async () => {
                  history.push(`/member/linked/t1`);
                }}
                className="button is-fullwidth is-save"
                style={{ marginTop: 10 }}
              >
                Next
              </button>
            </div>
          </div>
        </Route>

        <Route path={`${path}/member/missionsticker`}>
          {!loading && isMissionStickerCampaign() && (
            <div
              className="error-page has-text-centered"
              style={{ padding: 0, background: "#dae2ff", minHeight: "100vh" }}
            >
              <div style={{ minHeight: 400 }}>
                <img
                  src="/mission_stickers/sticker_landing01.jpg"
                  style={{ width: "100%" }}
                />

                <div className="screen-footer" style={{ paddingBottom: 40 }}>
                  <button
                    onClick={async () => {
                      setLoading(false);

                      let result = await axios.post(
                        `${AppConfig.endpoint}/member/binding`,
                        {},
                        {
                          headers: {
                            "x-access-token": liff.getAccessToken(),
                            "x-api-key": AppConfig.api_key,
                          },
                        }
                      );

                      if (result.data && result.data.url) {
                        // Redirect to signin screen
                        window.location.href = result.data.url;
                      }
                      setLoading(false);
                    }}
                    className="button is-fullwidth is-save"
                    style={{ marginTop: 10 }}
                  >
                    เชื่อมต่อบัญชี The 1
                  </button>

                  <button
                    onClick={async () => {
                      setLoading(true);
                      AATagging.trackSignup();
                      setTimeout(async () => {
                        let result = await axios.post(
                          `${AppConfig.endpoint}/member/binding`,
                          { mode: "signup" },
                          {
                            headers: {
                              "x-access-token": liff.getAccessToken(),
                              "x-api-key": AppConfig.api_key,
                            },
                          }
                        );

                        if (result.data && result.data.url) {
                          window.location.href = result.data.url;
                        }

                        setLoading(false);
                      }, 1500);
                    }}
                    className="button is-fullwidth is-save"
                    style={{ marginTop: 10 }}
                  >
                    ยังไม่เป็นสมาชิก? สมัครก่อนนะ
                  </button>
                </div>
              </div>
            </div>
          )}
        </Route>
        <Route path={`${path}/member/signup`}>{/* <MemberProfile /> */}</Route>
        <Route path={`${path}/member/profile`}>
          {app.currentUserProfile && <MemberProfile />}
        </Route>
        <Route path={`${path}/member/edit/email`}>
          {app.currentUserProfile && (
            <PinProtectScreen>
              <MemberEditEmail
                onUpdate={() => loadUserProfile(lineAccessToken)}
              />
            </PinProtectScreen>
          )}
        </Route>
        <Route path={`${path}/member/edit/mobile`}>
          {app.currentUserProfile && (
            <PinProtectScreen>
              <MemberEditMobile
                onUpdate={() => loadUserProfile(lineAccessToken)}
              />
            </PinProtectScreen>
          )}
        </Route>
        <Route path={`${path}/member/edit/address`}>
          {app.currentUserProfile && (
            <MemberEditAddress
              onUpdate={() => loadUserProfile(lineAccessToken)}
            />
          )}
        </Route>
        <Route path={`${path}/member/edit/interest`}>
          {app.currentUserProfile && (
            <MemberEditInterest
              onUpdate={() => loadUserProfile(lineAccessToken)}
            />
          )}
        </Route>
        <Route exact path={`${path}/member/link`}></Route>
        <Route exact path={`${path}/member/linked/:type`}>
          {app.currentUserProfile && <LinkedScreen />}
        </Route>
        <Route path={`${path}/member/message/unlinked`}>
          {/* <h1>Error Unlink</h1>
                {query.get("access_token")} */}
          <UnlinkWaitingScreen
            onComplete={() => loadUserProfile(lineAccessToken)}
            user_type={query.get("u")}
            member_id={query.get("m")}
          />
        </Route>

        <Route path={`${path}/member/error/unlink`}>
          {/* <h1>Error Unlink</h1>
                {query.get("access_token")} */}
          <UnlinkScreen
            access_token={query.get("access_token")}
            user_type={query.get("u")}
            member_id={query.get("m")}
            line_access_token={lineAccessToken}
          />
        </Route>
        <Route path={`${path}/member/error/unlink_contact`}>
          {/* <h1>Error unlink contact</h1>
                {query.get("access_token")} */}
          {lineAccessToken && (
            <div
              className="error-page has-text-centered"
              style={{ paddingTop: 40 }}
            >
              <img src="/linked_with_partner.png" style={{ width: 240 }} />
              <div className="subtitle">
                Line ID นี้ได้เชื่อมต่อกับบัญชี The 1 อื่นแล้ว!
              </div>
              <p>
                {" "}
                กรุณาติดต่อ The 1 Exclusive Call Center 0-2660-1000
                <br />
                ให้บริการทุกวัน เวลา 9.00 - 22.00 น.
              </p>
              <div className="screen-footer">
                <a
                  className="button is-fullwidth is-save"
                  style={{ marginTop: 10 }}
                  href="tel:+6626601000"
                >
                  โทร The 1 Call Center
                </a>
                <button
                  type="button"
                  className="button is-fullwidth is-outlined"
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    signOut(query.get("access_token"), lineAccessToken);
                  }}
                >
                  ย้อนกลับ
                </button>
                {/* <a className="button is-fullwidth is-outlined" style={{ marginTop: 10 }} onClick={() => liff.closeWindow()} >Cancel</a> */}
              </div>
            </div>
          )}
        </Route>

        <Route path={`${path}/member/error/binding`}>
          <h1>Error Binding</h1>
        </Route>

        <Route path={`${path}/member/error`}>
          <h1>Error...</h1>
          {/* {window.location.href} */}
        </Route>
      </Switch>
    </>
  );
}

export class UnlinkWaitingScreen extends React.Component {
  state = {
    countdown: 5,
  };
  componentDidMount() {
    let { member_id, user_type } = this.props;
    AATagging.trackAlreadyLinkUnlinkComplete(member_id, user_type === "t");

    setInterval(() => {
      let { countdown } = this.state;
      if (countdown > 0) {
        countdown--;
      }
      this.setState({ countdown });
      if (countdown <= 0) {
        // window.location.href = '/member'
        this.props.onComplete();
      }
    }, 1000);
  }

  render() {
    let { countdown } = this.state;
    return (
      <div className="error-page has-text-centered" style={{ paddingTop: 40 }}>
        <img src="/unlink.png" style={{ width: 80 }} />
        <div className="subtitle">
          Successfully unlinked your The 1 account with previous LINE ID!
        </div>
        <p>Please sign in to your The 1 account again.</p>
        <div className="waiting">
          Waiting...<span className="countdown">{countdown}</span>
        </div>
      </div>
    );
  }
}

export default withRouter(connect((state) => state, actions)(MemberRoutes));
